/** The rows a ranked table shows, and the helpers that build its filters —
 *  shared by the science site's tables and the app's. */

/**
 * One row of a ranked table. `facets` are what the table's own filters match
 * on — a page's section, a simulation's subject — and `search` is the text its
 * search box matches, which can be more than the label (a simulation's id and
 * its title).
 */
export type RankedRow = {
  key: string;
  label: string;
  sub?: string;
  users?: number;
  visits: number;
  events?: number;
  search: string;
  facets: Record<string, string[]>;
};

export type NumKey = 'users' | 'visits' | 'events';

/** A facet's values in a table, largest-first by how many rows carry each. */
export function facetOptions(rows: Pick<RankedRow, 'facets'>[], facet: string, label: (v: string) => string = v => v) {
  const count = new Map<string, number>();
  for (const r of rows) for (const v of r.facets[facet] ?? []) count.set(v, (count.get(v) ?? 0) + 1);
  return [...count.entries()].sort((a, b) => b[1] - a[1]).map(([value, n]) => ({ value, label: `${label(value)} (${n})` }));
}

/** A path's section — its first segment — as a reader names it. */
export const sectionOf = (path: string) => {
  const first = path.split('/').filter(Boolean)[0];
  return first ? `/${first}` : '/';
};
